import { render, staticRenderFns } from "./FCCCompetitionCompetitors.vue?vue&type=template&id=67a15438"
import script from "./FCCCompetitionCompetitors.vue?vue&type=script&lang=js"
export * from "./FCCCompetitionCompetitors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports